module.exports = __webpack_public_path__ + "img/logo.ff7a7e4a.png";